import { statusColorFromSensorStatus } from '@components/cockpit/panels/monitoring/monitoring.utils';
import { Tooltip } from '@components/ui/tooltip';
import { colors } from '@theme/foundations/colors';
import { ComponentType, SVGProps } from 'react';

import { HealthStatusEnum } from '@/types/sensor/sensors';

type Props = {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  x: number;
  y: number;
  isConnected: boolean;
  isPresent: boolean;
  name: string;
  status?: HealthStatusEnum;
};

export default function SquareInfo({ x, y, icon: Icon, isConnected, isPresent, name, status }: Readonly<Props>) {
  const statusColor = status ? statusColorFromSensorStatus[status] : colors.neutral['500'].value;
  return (
    <svg width="40" height="46" viewBox="0 0 40 46" fill="none" x={x} y={y}>
      <Tooltip content={name} contentProps={{ textStyle: 'xs', paddingY: 0.5, paddingX: 1 }}>
        <g>
          <rect width="40" height="46" fill={statusColor} />
          <g transform="translate(4, 2)" style={{ color: colors.neutral.black.value, opacity: isPresent ? 1 : 0.4 }}>
            <Icon />
          </g>
        </g>
      </Tooltip>
      <rect width="40" height="10" transform="translate(0 36)" fill={colors.neutral.black.value} />
      <rect
        x="2"
        y="38"
        width="36"
        height="6"
        fill={isPresent && isConnected ? colors.skyBlue.DEFAULT.value : colors.neutral['600'].value}
      />
    </svg>
  );
}
